module.exports = __webpack_public_path__ + "img/cross.796ccbca.svg";